import React, {useState, useEffect} from 'react'
import PubSub from 'services/PubSub/'
import Checkbox from 'components/Forms/Inputs/ChecksGroup/checkbox'
import LoginService from 'services/Login'
import DeliverySelectorService from 'services/DeliverySelector'
import Loader from 'components/Loader'
import style from './style.scss' //NOSONAR
import { actionsType } from 'config/constants'

let actions = []

const AddressSelection = (props) => {
    const {payload} = props
    const callback = payload?.value?.callback

    const [loading, setLoading] = useState(true)
    const [addresses, setAddress] = useState([])
    const [selected, setSelected] = useState('')
    const [selectedFull, setSelectedFull] = useState('')

    useEffect(() => {
        getAddresses()
    }, [])

    useEffect(() => {
        actions.push(PubSub.register('address_updated', getAddresses))

        return function cleanup() {
            actions = actions.map((token) => PubSub.unregister(token))
            actions = []
        }
    }, [])

    const getAddresses = (_payload) => {
        const token = LoginService.getUserToken()
        const payloadAddress = _payload?.value?.addressName

        setLoading(true)

        DeliverySelectorService.getAddress(token)
            .then((response) => {
                if (response.listAddress) {
                    setAddress(response.listAddress)
                }

                for (let _address of response.listAddress) {
                    if (_address.value.addressId === payloadAddress) {
                        setSelected(_address.value.addressId)
                        break
                    }
                }
            })
            .catch(() => {})
            .finally(() => {
                setLoading(false)
            })
    }

    const close = (payload) => {
        PubSub.dispatch(actionsType.DRAWER.ADDRESS_CLOSE)

        if (callback) {
            if (payload) {
                callback(payload)
            } else {
                callback()
            }
        }
    }

    const onChangeInput = (address) => {
        setSelected(address.value.addressId)
        setSelectedFull(address.value)
    }

    const clickSubmit = () => {
        close(selectedFull)
    }

    const openAddressModal = () => {
        PubSub.dispatch('address_open', {
            addressUpdate: null,
        })
    }

    if (loading) return <Loader />

    return (
        <div className={'drawer-container'}>
            <h1 className="drawer-title">Dirección de entrega</h1>
            <div className={'drawer-scroll'}>
                {addresses &&
                    addresses.map((address, i) => {
                        return (
                            <li className={'address-item'} key={i}>
                                <Checkbox type={'checkbox'} name={'Address'} checked={Boolean(address?.value?.addressId === selected)} onChange={() => onChangeInput(address)} />
                                <span className="address-item-title" onClick={() => onChangeInput(address)}>
                                    {address.saved && <span className="address-item-frequently">Dirección frecuente</span>}
                                    {address.label}
                                </span>
                            </li>
                        )
                    })}
                <button className="new-link" onClick={openAddressModal}>
                    Agregar dirección
                </button>
            </div>
            <div className="drawer-actions">
                <button className="secundary-btn" onClick={close}>
                    Volver
                </button>
                <button
                    className={'btn-drawer-address-selection-confirm' + (selected ? ' primary-btn' : ' disabled-btn')}
                    onClick={clickSubmit}>
                    {!loading ? <span>Confirmar</span> : <Loader />}
                </button>
            </div>
        </div>
    )
}

export default AddressSelection
